// extracted by mini-css-extract-plugin
export var dividerLine = "_5v-0";
export var errorBackground = "_5v-1";